import React, { Component } from 'react';


class WordVoice extends Component {
  constructor(props) {
    super(props);

    this.audioContext = null;
    this.buffers = {};
    this.state = {
      urls: [],
    };
  }

  copyState() {
    const state = Object.assign({}, this.state);
    state.urls = state.urls.map(url => Object.assign({}, url));
    return state;
  }

  componentDidMount() {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new AudioContext();
    if (this.props.urls) {
      this.updateUrls();
    }
  }

  componentDidUpdate() {
    this.updateUrls();
  }

  updateUrls() {
    const notLoadedUrls = this.props.urls.filter(url => !this.state.urls.includes(url));
    if (notLoadedUrls.length == 0) {
      return;
    }
    this.loadUrls(notLoadedUrls)
      .then(() => {
        console.log('Success', Object.keys(this.buffers));
      })
      .catch(error => {
        console.error('Error', error);
      });
  }

  async loadUrls(urls) {
    const buffers = await Promise.all(urls.map(url => this.loadInternal(url)));
    urls.forEach((url, index) => {
      this.buffers[url] = buffers[index];
    });
    const state = this.copyState();
    state.urls = state.urls.concat(urls);
    this.setState(state);
    if (this.props.onLoad) {
      this.props.onLoad(urls);
    }
  }

  play(url) {
    const source = this.audioContext.createBufferSource();
    source.buffer = this.buffers[url];
    source.connect(this.audioContext.destination);
    source.start(0);
  }

  loadInternal(url) {
    const self = this;
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'arraybuffer';

      request.onload = () => {
        self.audioContext.decodeAudioData(request.response, buffer => {
          resolve(buffer);
        }, error => {
          resolve(null);
          console.warn('Cannot load', url);
        });
      }
      request.send();
    });
  }

  render() {
    return (
      <div>
      </div>
    );
  }
}

export default WordVoice;
